import React from 'react'
import Layout from '../layout/Layout'

const NotFound = () => {
    return (
        <Layout>
            <h1 className="max-w-md text-4xl font-bold md:text-5xl text-left">
                Not Found
            </h1>

        </Layout>
    )
}

export default NotFound;